module.exports = __webpack_public_path__ + "assets/4325cdf041b23e26642584a472547c49.mp3";